<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Execution Import</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="primary"
                @click="emailChecklist('PAYTEST')"
                id="addButtonLoaderVGM"
                >S-Line Payment Request</b-button
              >
              <!-- <b-button v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" size="sm" variant="primary" @click="emailChecklist('PAYTEST')" id="addButtonLoaderVGM">S-Line Payment Request</b-button> -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="EXPORTER ? EXPORTER : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{mainEntryData[0].ccImportSeries}}</b>
                  </md-layout>
                </md-layout>
               
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{mainEntryData[0].Importer}}</b>
                  </md-layout>
                </md-layout>
              
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{mainEntryData[0].Exporter}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card>
            <hr> -->
            <md-layout md-gutter>
              <md-layout md-flex="20">
                <label>Assessment Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="bookingDate"
                  name="bookingDate"
                  v-model="ExecutionModel.originalDate"
                ></date-picker>
                <span class="error" v-if="!ExecutionModel.originalDate">{{
                  errorExecutionModel.originalDate
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label>Duty Challan No.<span class="error">*</span></label>
                <b-input
                  name="securityAmount"
                  id="securityAmount"
                  v-model="ExecutionModel.securityAmount"
                ></b-input>
                <span class="error" v-if="!ExecutionModel.securityAmount">{{
                  errorCustomValidation.securityAmount
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label> Challan Amount </label>
                <b-input
                  name="trSubmitNumber"
                  id="trSubmitNumber"
                  v-model="ExecutionModel.trSubmitNumber"
                ></b-input>
                <span class="error" v-if="!ExecutionModel.trSubmitNumber">{{
                  errorExecutionModel.trSubmitNumber
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Challan Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="trSubmitDate"
                  name="trSubmitDate"
                  v-model="ExecutionModel.trSubmitDate"
                ></date-picker>
                <span class="error" v-if="!ExecutionModel.trSubmitDate">{{
                  errorExecutionModel.trSubmitDate
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="20">
                <label for="stuffingType">Duty Paid</label>

                <model-list-select
                  :list="checkList"
                  v-model="ExecutionModel.checkDoHard"
                  option-value="value"
                  option-text="value"
                  placeholder="Select"
                ></model-list-select>
                <span class="error" v-if="!ExecutionModel.checkDoHard">{{
                  errorExecutionModel.checkDoHard
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20" v-if="ExecutionModel.checkDoHard == 'Paid'">
                <label for="stuffingType">Paid By</label>

                <model-list-select
                  :list="paidByList"
                  v-model="ExecutionModel.checkOriginalInvoice"
                  option-value="paidV"
                  option-text="paidT"
                  placeholder="Select Paid By"
                ></model-list-select>
                <!-- <span
              class="error"
              v-if="!ExecutionModel.checkOriginalInvoice"
                >{{errorExecutionModel.checkOriginalInvoice}}</span>-->
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15" v-if="ExecutionModel.checkDoHard == 'Paid'">
                <label>Payment Date<span class="error">*</span></label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="receivedDo"
                  name="receivedDo"
                  v-model="ExecutionModel.receivedDo"
                ></date-picker>
                <span class="error" v-if="!ExecutionModel.receivedDo">{{
                  errorCustomValidation.receivedDo
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>Out of Charge Date<span class="error">*</span></label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="outOfChargeDate"
                  name="outOfChargeDate"
                  v-model="ExecutionModel.outOfChargeDate"
                ></date-picker>
                <span class="error" v-if="!ExecutionModel.outOfChargeDate">{{
                  errorCustomValidation.outOfChargeDate
                }}</span>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-input-container>
              <label>First Copy Upload</label>
              <md-file
                name="uploadboe"
                id="boe"
                v-model="ExecutionModel.firstCopyUpload"
                @selected="onFileChangeBoe('first')"
              ></md-file>
            </md-input-container>
            <span
              class="error"
              v-if="!ExecutionModel.firstCopyUpload"
            >{{errorExecutionModel.firstCopyUpload}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter v-if="firstBlUploadView.length>0">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15" v-for="(item,index) in firstBlUploadView" :key="index">
            <a
              :href="'http://13.229.240.246/ccImportExec/'+item"
              target="_blank"
              download
            >View Document - {{index+1}}</a>
          </md-layout>
            </md-layout>-->

            <div class="mt-3">
              <h5><b-badge>DO And Security Details</b-badge></h5>
            </div>

            <b-card class="mt-2" style="background: whiteSmoke">
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <!-- Other Services -->
                </md-layout>
                <md-layout md-flex="70"></md-layout>
              </md-layout>
              <div
                v-for="(item, index) in ExecutionModel.doSection"
                :key="index"
                style="margin-bottom: 15px; background: whiteSmoke"
              >
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="25">
                    <label for="stuffingType">
                      <b>Do / Security</b>
                    </label>
                    <model-list-select
                      :list="doSecurityList"
                      v-model="item.doOrSecurity"
                      option-value="doSecV"
                      option-text="doSecT"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <md-layout
                  md-gutter
                  class="gutr"
                  style="margin-bottom: 15px; background: whiteSmoke"
                >
                  <md-layout md-flex="25">
                    <label for="stuffingType">Particulars</label>
                    <b-textarea
                      style="height: 37px"
                      name="securityAmount"
                      id="securityAmount"
                      v-model="item.doParticulars"
                    ></b-textarea>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label for="stuffingType">Paid By</label>

                    <model-list-select
                      :list="paidByList"
                      v-model="item.doPaidBy"
                      option-value="paidV"
                      option-text="paidT"
                      placeholder="Select Paid By"
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="15">
                    <label>Payment Date</label>

                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      id="receivedDo"
                      name="receivedDo"
                      v-model="item.doPaymentDate"
                    ></date-picker>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="25">
                    <label for="stuffingType">Remarks</label>
                    <b-textarea
                      style="height: 37px"
                      name="securityAmount"
                      id="securityAmount"
                      v-model="item.doRemark"
                    ></b-textarea>
                  </md-layout>
                  <b-button
                    v-if="index == '0'"
                    size="sm"
                    class="ml-2"
                    variant="outline-dark"
                    style="margin-top: 38px"
                    @click="addAdditionalDo"
                  >
                    <md-icon>add</md-icon>
                  </b-button>
                  <b-button
                    v-else
                    size="sm"
                    class="ml-2"
                    variant="outline-dark"
                    style="margin-top: 38px"
                    @click="removeDoSection(index)"
                  >
                    <md-icon>remove</md-icon>
                  </b-button>
                </md-layout>
              </div>
            </b-card>

            <md-layout md-gutter class="gutr">
              <b-button
                size="sm"
                style="margin-top: 38px"
                @click="showDocModal"
                variant="dark"
                >Upload DO</b-button
              >

              <!-- <md-layout md-flex="45">
                <md-input-container>
                  <label>Upload Delivery Order(DO)</label>
                  <md-file
                    name="uploadboe"
                    id="boe"
                    v-model="ExecutionModel.uploadDo"
                    @selected="onFileChangeBoe"
                  ></md-file>
                </md-input-container>
                <span class="error" v-if="!ExecutionModel.uploadDo">{{errorExecutionModel.uploadDo}}</span>
              </md-layout> -->

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label>Do Release Date</label>

                <date-picker
                  :format="selectDateFormat"
                  lang="en"
                  id="receivedDo"
                  name="receivedDo"
                  v-model="ExecutionModel.doReleaseDate"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="doRemarks"
                    name="doRemarks"
                    v-model="ExecutionModel.doRemarks"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="secBlUploadView.length > 0">
              <md-layout
                md-flex="30"
                v-for="(item, index) in secBlUploadView"
                :key="index"
              >
                <a :href="`${docURL}/CC_Import_Uploads/` + item" target="_blank" download
                  >View Document - {{ index + 1 }}</a
                >
              </md-layout>
            </md-layout>

            <div class="gutr">
              <b-button
                class="mt-3"
                variant="primary"
                id="addButtonLoaderpro"
                @click="addExecution('0')"
                >Save & Submit</b-button
              >
            </div>
            <div>
              <b-button
                class="mt-1"
                variant="primary"
                id="addButtonLoaderpro"
                @click="addExecution('1')"
                >Save & Proceed To Tracking</b-button
              >

              <md-spinner
                md-indeterminate
                id="loaderpro"
                style="display: none"
              ></md-spinner>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseHandover"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != "" &&
      this.$sessionsStorage.get("editCcType") != undefined &&
      this.$sessionsStorage.get("editCcType") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCImportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      // CUstom Validation Variable Declaration Start 23/06/2023
      errorCustomValidation: {
        securityAmount: "",
        receivedDo: "",
        outOfChargeDate: "",
      },

      arrayErrorCustomValidation: [
        {
          securityAmount: "Enter Duty Challan No. ",
          receivedDo: "Enter Duty Payment Date",
          outOfChargeDate: "Enter Out of Charge Date",
        },
      ],
      // CUstom Validation Variable Declaration End 23/06/2023

      syncType: "",
      syncSeries: "",
      syncFlag: false,
      invnoErrFlag: false,
      selectDateFormat,
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {},
      },
      editorContent: "",
      validate: true,
      isLoading: true,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      checkList: [
        {
          value: "Paid",
        },
        {
          value: "Pending",
        },
      ],
      paidByList: [
        {
          paidV: "1",
          paidT: "Pridel",
        },
        {
          paidV: "2",
          paidT: "Importer ",
        },
      ],
      doSecurityList: [
        {
          doSecV: "1",
          doSecT: "Shipping Line Invoice",
        },
        {
          doSecV: "2",
          doSecT: "Security Details",
        },
      ],
      ALLMODULE: "",
      JOBSERIES: "",
      EXPORTER: "",
      TYPE: "",
      mainEntryData: [],
      // Added By Priyanshu Singh Start
      ccExecDetail: [],
      pageRoute: "",
      EdiExecutionModel: {
        allModuleId: "",
        checklistUpload: "",
        vgmUpload: "",
        vgmBy: "",
        ediExecutionId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: "",
        assignmentNumber: "",
        DIN: "",
        IRN: "",
        billEntryNumber: "",
        uploadBoe: [],
        billEntryDate: "",
        challanNo: "",
        mainRemarks: "",
      },
      // Added By Priyanshu Singh End
      ExecutionModel: {
        uploadDO: "",
        doReleaseDate: "",
        doRemarks: "",
        executionImportId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: "Import",
        originalDate: "",
        firstCopyUpload: "",
        trSubmitDate: "",
        trSubmitNumber: "",
        securityAmount: "",
        uploadDo: "",
        receivedDo: "",
        checkOriginalInvoice: "",
        checkDoHard: "",
        outOfChargeDate: "",
        doSection: [
          {
            doOrSecurity: "",
            doParticulars: "",
            doPaymentDate: "",
            doPaidBy: "",

            doRemark: "",
          },
        ],
      },
      errorExecutionModel: {
        originalDate: "",
        //  firstCopyUpload: "",
        trSubmitDate: "",
        trSubmitNumber: "",
        securityAmount: "",
        // uploadDo: "",
        //  receivedDo: "",
        //  checkOriginalInvoice: "",
        checkDoHard: "",
      },
      arrayErrorExecutionModel: {
        originalDate: "Select Date",
        // firstCopyUpload: "Please Upload file",
        trSubmitDate: "Select TR Date",
        trSubmitNumber: "Enter TR Number",
        securityAmount: "Enter Container Security Amount",
        // uploadDo: "Please Upload file",
        //  receivedDo: "Select Recieved Date",
        // checkOriginalInvoice: "Select Yes/No",
        checkDoHard: "Select Yes/No",
      },
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    BannerComponent,
    DocForm,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    // firstBlUploadView() {
    //   return this.ExecutionModel.firstCopyUpload != ""
    //     ? this.ExecutionModel.firstCopyUpload.split(",")
    //     : [];
    // },
    secBlUploadView() {
      // alert(this.ExecutionModel.uploadDo)
      return this.ExecutionModel.uploadDo != "" &&
        this.ExecutionModel.uploadDo != null &&
        this.ExecutionModel.uploadDo != undefined
        ? this.ExecutionModel.uploadDo.split(",")
        : [];
    },
  },

  methods: {
    checkSlinePayment() {
      return new Promise((resolve) => {
        let payLoad = {
          module_type: "CC Import",
          allModuleId: this.ALLMODULE,
          assignment_no: this.JOBSERIES,
          type: this.TYPE,
        };
        // console.log("MypayLoad=>",payLoad.length);return false;
        if (payLoad != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkSlinePaymentcreated.php`,
            data: JSON.stringify(payLoad),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                  this.syncType = data.moduleType;
                  this.syncSeries = data.mainSalesSeries;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }
                this.syncFlag = true;
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => {});
        }
      });
    },
    async emailChecklist(id) {
      if (id == "PAYTEST") {
        let checkValueExit = await this.checkSlinePayment();
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          if (this.syncType != "CC Import") {
            this.alert.content = this.alert.content =
              "The Payment Request has Already been Raised in '" +
              this.syncType +
              "' Assignment No. '" +
              this.syncSeries +
              "'";
            this.$refs["message"].open();
            return false;
          }
        }
      }
      // alert(this.$sessionsStorage.get("editCcImportId"));

      // this.EdiExecutionModel["multiShippingBill"] = this.multiShippingBill;

      // Added By Priyanshu Singh Start

      this.$sessionsStorage.set("allModuleId", this.ALLMODULE);
      this.$sessionsStorage.set("TYPE", this.TYPE);
      this.$sessionsStorage.set("JOBSERIES", this.JOBSERIES);
      this.$sessionsStorage.set("EXPORTER", this.EXPORTER);
      // Added By Priyanshu Singh End
      // alert(this.TYPE);
      //     alert(this.EXPORTER);
      this.pageRoute = id;
      this.validateCheckList(id);
      // console.log(this.$sessionsStorage.get());

      this.EdiExecutionModel["ccImportId"] = this.$sessionsStorage.get("editCcImportId");
      console.log(this.ccExecDetail);
      if (this.ccExecDetail.length > 0) {
        this.EdiExecutionModel.ediExecutionId = this.ccExecDetail[0].executionImportId;
      }

      // Added By Priyanshu Singh Start
      this.EdiExecutionModel["ccImportId"] = this.$sessionsStorage.get("editCcImportId");
      this.EdiExecutionModel["allModuleId"] = this.$sessionsStorage.get("allModuleId");
      this.EdiExecutionModel["TYPE"] = this.$sessionsStorage.get("TYPE");
      this.EdiExecutionModel["JOBSERIES"] = this.$sessionsStorage.get("JOBSERIES");
      this.EdiExecutionModel["EXPORTER"] = this.$sessionsStorage.get("EXPORTER");
      // Added By Priyanshu Singh End
      // console.log("this.EdiExecutionModel=>",this.EdiExecutionModel);return false;
      let Obj = {
        EdiExecutionModel: this.EdiExecutionModel,
        //   UploadChecklist: this.UploadChecklist,
        onlyExecMain: id == "" ? "" : "fsdf",
      };

      if (this.validate == true) {
        this.isLoading = true;
        if (id == "vgm") {
          $("#addButtonLoaderVgm").css("display", "none");
          $("#loaderVgm").css("display", "block");
        } else if (id == "handover") {
          $("#addButtonLoaderHand").css("display", "none");
          $("#loaderHand").css("display", "block");
        } else if (id == "BL") {
          $("#addButtonLoaderBL").css("display", "none");
          $("#loaderBL").css("display", "block");
        } else {
          $("#addButtonLoaderPay").css("display", "none");
          $("#loaderPay").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addEdiExecution.php`,
          data: JSON.stringify(Obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // alert("hellow");
              // console.log("My Data=>",data);
              // return false;
              // // if (this.mainEntryData[0].newContainerFlow == "1") {
              // Added By Priyanshu Singh Start
              this.$sessionsStorage.set("editCCExecutionId", data.ediExecutionId);
              // Added By Priyanshu Singh End
              //   this.factoryStuffing.editCCExecutionId = data.ediExecutionId;
              // }
              // Object.keys(this.UploadChecklist).map(x => {
              //   this.UploadChecklist[x] = "";ediExecutionId
              // });

              //  this.uploadIndex = 0;
              //   this.getData();
              if (id != "") {
                this.alert.content = "Data Updated Succesfully";
                if (id == "0") {
                  this.$refs["message"].open();
                } else {
                  this.$refs["alertAddSeaImp"].open();
                }
              }

              if (id == "vgm") {
                $("#addButtonLoaderVgm").css("display", "block");
                $("#loaderVgm").css("display", "none");
              } else if (id == "BL") {
                $("#addButtonLoaderBL").css("display", "block");
                $("#loaderBL").css("display", "none");
              } else if (id == "handover") {
                $("#addButtonLoaderHand").css("display", "block");
                $("#loaderHand").css("display", "none");
              } else {
                $("#addButtonLoaderPay").css("display", "block");
                $("#loaderPay").css("display", "none");
              }
              this.isLoading = false;
              if (id == "0") {
                this.getData();
              }
              // this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },

    addAdditionalDo() {
      let doSection1 = {
        doOrSecurity: "",
        doParticulars: "",
        doPaidBy: "",

        doPaymentDate: "",
        doRemark: "",
      };

      this.ExecutionModel.doSection.push(doSection1);
    },
    removeDoSection(index) {
      this.ExecutionModel.doSection.splice(index, 1);
      //  this.errorMultiContainer.splice(index, 1);
    },
    onFileChangeSecondBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then((result) => {
          this.ffHouseBL.secondBLupload = result.data;
          // console.log("fdsf", result.data);
        })
        .catch((err) => {
          throw err;
        });
    },

    validateCheckList(id) {
      let validate_new = true;

      Object.keys(this.errorExecutionModel).map((x) => {
        if (this.ExecutionModel[x] == "") {
          validate_new = false;
          this.errorExecutionModel[x] = this.arrayErrorExecutionModel[x];
        } else {
          this.errorExecutionModel[x] = "";
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    onCloseHandover(type) {
      if (type != "cancel") {
        // alert(this.pageRoute);
        if (this.pageRoute == "PAYTEST") {
          this.$router.push({
            path: "/CCImport/ccSLinePaymentImportN",
          });
        } else {
          this.$router.push({
            path: "/CCImport/ccImportTracking",
          });
        }
      }
    },
    // CUstom Validation Variable Declaration Start 23/06/2023
    validateFFImportCustomVali() {
      let validate_new = true;
      Object.keys(this.errorCustomValidation).map((x, index) => {
        if (
          this.ExecutionModel[x] == "" ||
          this.ExecutionModel[x] == 0 ||
          this.ExecutionModel[x] == undefined ||
          this.ExecutionModel[x] == null ||
          this.ExecutionModel[x] == "undefined" ||
          this.ExecutionModel[x] == "null"
        ) {

            console.log("this.errorCustomValidation[x] x=>", x);
            console.log("this.errorCustomValidation[x]=>", this.errorCustomValidation[x]);
            console.log(
              "this.arrayErrorCustomValidation[0][x]=>",
              this.arrayErrorCustomValidation[0][x]
            );
            this.errorCustomValidation[x] = this.arrayErrorCustomValidation[0][x];
               if (
              (x == "receivedDo" && this.ExecutionModel.checkDoHard == "Paid") ||
              (x == "securityAmount") ||
              (x == "outOfChargeDate")
            ) {
              validate_new = false;
            }
            // validate_new = false;
          
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    // CUstom Validation Variable Declaration End 23/06/2023
    addExecution(id) {
      this.validateCheckList();
      this.ExecutionModel.doSecurityArr = JSON.stringify(this.ExecutionModel.doSection);
      console.log(this.ExecutionModel);
      console.log(this.errorExecutionModel);
      // return false;
      // alert(this.validate);
      // CUstom Validation Variable Declaration Start 23/06/2023
      this.validateFFImportCustomVali(); // Custom Validation 23/06/2023
      console.log("Priyanshu SIngh=>", this.validate);
      console.log("Priyanshu SIngh errorCustomValidation =>", this.errorCustomValidation);
      console.log(
        "Priyanshu SIngh arrayErrorCustomValidation =>",
        this.arrayErrorCustomValidation
      );
      // return false;
      // CUstom Validation Variable Declaration End 23/06/2023
      if (this.validate == true) {
        $("#addButtonLoaderpro").css("display", "none");
        $("#loaderpro").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addImportExecution.php`,
          data: JSON.stringify(this.ExecutionModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoaderpro").css("display", "block");
              $("#loaderpro").css("display", "none");

              if (this.ExecutionModel.executionImportId != "") {
                this.alert.content = "Data Updated Succesfully";
              } else {
                this.alert.content = "Data Inserted Succesfully";
              }
              if (id == "0") {
                this.$refs["message"].open();
              } else {
                this.$refs["alertAddSeaImp"].open();
              }
              // this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.isLoading = true;

      let array = [];
      let doOrSecurity = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchImportExec.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "jitu");
            let otherNewContainerFLow = 0;
            let doReleaseDate = "";
            let doRemarks = "";
            let uploadDo = [];
            let doSectionArr = [];
            // alert(data.ccImportDetails.length)
            if (data.ccImportDetails.length > 0) {
              this.mainEntryData = data.ccImportDetails;
              this.ALLMODULE = data.ccImportDetails[0].allModuleId;
              this.JOBSERIES = data.ccImportDetails[0].ccImportSeries;
              this.clientName = data.ccImportDetails[0].Exporter;
              this.EXPORTER = data.ccImportDetails[0].Importer;
              this.TYPE = data.ccImportDetails[0].ccType;
              this.EdiExecutionModel.assignmentNumber =
                data.ccImportDetails[0].ccImportSeries;
              this.EdiExecutionModel.ccType = data.ccImportDetails[0].ccType;
              this.ExecutionModel.otherNewContainerFLow =
                data.ccImportDetails[0].otherNewContainerFLow;
              this.ExecutionModel.allModuleId = data.ccImportDetails[0].allModuleId;
              otherNewContainerFLow = data.ccImportDetails[0].otherNewContainerFLow;
              if (otherNewContainerFLow == 1) {
                this.ExecutionModel.doSecurityArr = data.ccImportDetails[0].doSecurityArr;
                this.ExecutionModel.doReleaseDate = data.ccImportDetails[0].doReleaseDate;
                this.ExecutionModel.doRemarks = data.ccImportDetails[0].doRemarks;
                this.ExecutionModel.uploadDo = data.ccImportDetails[0].uploadDo;
                this.ExecutionModel.receivedDo = data.ccImportDetails[0].receivedDo;
                this.ExecutionModel.outOfChargeDate =
                  data.ccImportDetails[0].outOfChargeDate;

                // doSectionArr = data.ccImportDetails[0].doSecurityArr;
                otherNewContainerFLow = data.ccImportDetails[0].otherNewContainerFLow;
                if (
                  data.ccImportDetails[0].doSecurityArr != undefined &&
                  data.ccImportDetails[0].doSecurityArr != null &&
                  data.ccImportDetails[0].doSecurityArr != ""
                ) {
                  doSectionArr = data.ccImportDetails[0].doSecurityArr;
                }
                // doSectionArr = data.ccImportDetails[0].doSecurityArr;
                doReleaseDate = data.ccImportDetails[0].doReleaseDate;
                doRemarks = data.ccImportDetails[0].doRemarks;
                uploadDo = data.ccImportDetails[0].uploadDo;
                // alert(doSectionArr.length);
              }
            }
            // alert(otherNewContainerFLow);
            // alert(doSectionArr.length);
            if (data.ccExecDetail.length > 0) {
              this.ccExecDetail = data.ccExecDetail;
              this.EdiExecutionModel.ediExecutionId = data.ccExecDetail[0].ediExecutionId;
              Object.keys(this.EdiExecutionModel).map((x) => {
                this.EdiExecutionModel[x] = data.ccExecDetail[0][x] || "";
              });
              let doParticulars = [];
              let doRemark = [];
              let doPaymentDate = [];
              let doPaidBy = [];
              Object.keys(data.ccExecDetail[0]).map((x) => {
                if (x == "doOrSecurity") {
                  doOrSecurity = data.ccExecDetail[0][x].split(",");
                } else if (x == "doParticulars") {
                  doParticulars = data.ccExecDetail[0][x].split(",");
                } else if (x == "doRemark") {
                  doRemark = data.ccExecDetail[0][x].split(",");
                } else if (x == "doPaymentDate") {
                  doPaymentDate = data.ccExecDetail[0][x].split(",");
                } else if (x == "doPaidBy") {
                  doPaidBy = data.ccExecDetail[0][x].split(",");
                } else {
                  this.ExecutionModel[x] = data.ccExecDetail[0][x] || "";
                }
              });
              this.ExecutionModel["doSection"] = [];
              if (otherNewContainerFLow == 0) {
                if (doOrSecurity.length > 0) {
                  doOrSecurity.map((p, index) => {
                    let obj = {
                      doOrSecurity: p,
                      doParticulars: doParticulars[index],
                      doPaymentDate: doPaymentDate[index],
                      doRemark: doRemark[index],
                      doPaidBy: doPaidBy[index],
                    };

                    this.ExecutionModel.doSection.push(obj);
                  });
                }
              }
            }

            if (otherNewContainerFLow == 1) {
              this.ExecutionModel.doSection = [];
              if (doSectionArr.length > 0) {
                this.ExecutionModel.doSection = doSectionArr;
              } else {
                this.ExecutionModel.doSection.push({
                  doOrSecurity: "",
                  uploadDoC: "",
                  doParticulars: "",
                  doPaidBy: "",
                  doPaymentDate: "",
                });
              }
              this.ExecutionModel.doReleaseDate = doReleaseDate;
              this.ExecutionModel.doRemarks = doRemarks;
              this.ExecutionModel.uploadDo = uploadDo ? uploadDo : [];
              this.ExecutionModel.otherNewContainerFLow = otherNewContainerFLow;
            }

            // if (data.ccExecDetail.length > 0) {
            //   Object.keys(this.ExecutionModel).map(x => {
            //     this.ExecutionModel[x] = data.ccExecDetail[0][x] || "";
            //   });
            // }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/ediExecution"
      // });
    },
    onFileChangeBoe() {
      let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", this.$sessionsStorage.get("editCcImportId"));

        formData.append("staticFileName", "Import_Exec_Delivery_Order");

        formData.append("upload_dir_folderName", "CC_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          this.ExecutionModel.uploadDo = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ExecutionImport.vue?160e935e